"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _FunnelSteps = _interopRequireDefault(require("@rsuite/icon-font/lib/charts/FunnelSteps"));

// Generated by script, don't edit it please.
var FunnelSteps = (0, _createSvgIcon["default"])({
  as: _FunnelSteps["default"],
  ariaLabel: 'funnel steps',
  category: 'charts',
  displayName: 'FunnelSteps'
});
var _default = FunnelSteps;
exports["default"] = _default;
module.exports = exports.default;